import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SendEmailMessageComponent } from 'app/pages/email-messages/send-email-message/send-email-message.component';
import { SendSmsMessageComponent } from 'app/pages/sms-messages/send-sms-message/send-sms-message.component';
import { ModalBaseComponent } from 'app/shared/components/base/modal-base/modal-base.component';
import { Permissions } from 'app/shared/constants/permissions';
import { Sections } from 'app/shared/constants/sections';
import { EmailMessage } from 'app/shared/models/email-message.model';
import { SmsMessage } from 'app/shared/models/sms-message.model';
import { PaymentRequestService } from 'app/shared/services/payment-request.service';
import { SectionService } from 'app/shared/services/section.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-payment-request-url',
  templateUrl: './payment-request-url.component.html',
  styleUrls: ['./payment-request-url.component.scss']
})

export class PaymentRequestUrlComponent extends ModalBaseComponent implements OnInit {

  @Input() currentObject: any;

  subject: string;
  body: string;
  smallBody: string;
  urlCopiedToClipboardMessage: string;

  get hasSendUrlBySmsPermission(): boolean {
    return this.hasPermission(Permissions.PaymentRequestUrl_SendUrlBySms);
  }

  get hasSendUrlByEmailPermission(): boolean {
    return this.hasPermission(Permissions.PaymentRequestUrl_SendUrlByEmail);
  }

  get emailUrl(): string {
    return "mailto:?subject=" + this.subject + "&body=" + encodeURIComponent(this.body);
  }

  get smsUrl(): string {
    return "sms:?body=" + encodeURIComponent(this.smallBody);
  }

  get whatsAppUrl(): string {
    return "whatsapp://send?text=" + encodeURIComponent(this.body);
  }

  get hidePayDirect(): boolean {
    return !(this.currentObject.IsUpgradeCreditRequest && !this.currentObject.IsCompleted && this.hasDesktopView);
  }

  constructor(public paymentRequestService: PaymentRequestService, protected sectionService: SectionService, protected modalService: NgbModal, private toastrService: ToastrService,
              protected activeModal: NgbActiveModal, protected translateService: TranslateService, private router: Router, public datepipe: DatePipe) {
    super(activeModal, sectionService, Sections.PaymentRequestUrl);
  }

  ngOnInit() {
    super.initialize();
    // Includes the time: a Client-Controlled request can expire at a precise moment, and a date-only
    // message tells the payer the link is good for the rest of the day when it is not.
    let expirationDate = this.datepipe.transform(this.currentObject.ExpirationDate, 'dd-MM-yyyy HH:mm');
    this.translateService.get(['paymentRequestUrl.sharePaymentRequestSubject', 'paymentRequestUrl.sharePaymentRequestBody', 'paymentRequestUrl.sharePaymentRequestSmallBody',
        'paymentRequestUrl.urlCopiedToClipboardMessage'],
      {
        CompanyName: this.currentObject.CompanyName,
        RemittanceInformation: this.currentObject.RemittanceInformation,
        AmountCurrency:
        this.currentObject.AmountCurrency,
        AuthorizationUrl: this.currentObject.AuthorizationUrl,
        ExpirationDate: expirationDate
      })
      .subscribe(translations => {
        this.subject = translations['paymentRequestUrl.sharePaymentRequestSubject'];
        this.body = translations['paymentRequestUrl.sharePaymentRequestBody'];
        this.smallBody = translations['paymentRequestUrl.sharePaymentRequestSmallBody'];
        this.urlCopiedToClipboardMessage = translations['paymentRequestUrl.urlCopiedToClipboardMessage'];
      });
  }

  copyUrl(value: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    if (document.execCommand('copy')) {
      this.toastrService.info(this.urlCopiedToClipboardMessage);
    }
    document.body.removeChild(selBox);
  }

  sendUrlBySms() {
    const modalReference = this.modalService.open(SendSmsMessageComponent, {windowClass: 'add-edit-modal'});
    var smsMessage: SmsMessage = new SmsMessage();
    smsMessage.Content = this.smallBody;
    modalReference.componentInstance.currentObject = Object.assign({}, smsMessage);
  }

  sendUrlByEmail() {
    const modalReference = this.modalService.open(SendEmailMessageComponent, {windowClass: 'add-edit-modal'});
    var emailMessage: EmailMessage = new EmailMessage();
    emailMessage.Subject = this.subject;
    emailMessage.Body = this.body;
    modalReference.componentInstance.currentObject = Object.assign({}, emailMessage);
  }

  onSubmit(form: NgForm) {
    this.handleSubmit(form);
    window.open(this.currentObject.AuthorizationUrl, '_blank');
  }

  closeModal() {
    super.closeModal();
    this.afterSubmitEvent.emit();
  }
}
